import { useAxios } from "./useAxios";
import { FIELD_VISIT_LOG } from "../api/urls";
import { useCallback } from "react";
const requestFarmerVerificationOTP = async (axiosInstance, payload) => {
  try {
    const response = await axiosInstance.post(FIELD_VISIT_LOG, payload, {
      headers: { "Content-Type": "application/json" },
    });
    return { data: response.data };
  } catch (err) {
    return {
      error:
        err.response?.data?.message ||
        err.response?.data?.detail ||
        "OTP request failed",
      status: err.response?.status,
    };
  }
};

const submitFieldWorkLog = async (axiosInstance, formData) => {
  try {
    const response = await axiosInstance.post(FIELD_VISIT_LOG, formData, {
      headers: { "Content-Type": "multipart/form-data" },
    });
    return { data: response.data };
  } catch (err) {
    return {
      error:
        err.response?.data?.message ||
        err.response?.data?.detail ||
        "Field work log submission failed",
      status: err.response?.status,
    };
  }
};

export function useSubmitFieldWorkLog() {
  const axios = useAxios();
  return useCallback(
    (formData) => submitFieldWorkLog(axios, formData),
    [axios],
  );
}

export function useRequestFarmerVerificationOTP() {
  const axios = useAxios();
  return useCallback(
    (payload) => requestFarmerVerificationOTP(axios, payload),
    [axios],
  );
}
